export const expireOptions = [
  { value: 'never', label: 'Never' },
  { value: '1440', label: 'After 1 day' },
  { value: '10080', label: 'After 7 days' },
  { value: '43200', label: 'After 30 days' },
  { value: '129600', label: 'After 90 days' },
];
